import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../../common/manipurCommon/FunctionCalls"
import * as api from "../../../common/manipurCommon/API";
import Utils from "../../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";

const Competitions = () => {

    const [compsList, setCompsList] = useState<any[]>([]);
    const [compTypeList, setCompTypeList] = useState<any[]>([]);
    const [sportList, setSportList] = useState<any[]>([]);
    const [compCatList, setCompCatList] = useState<any[]>([]);
    const [classList, setClassList] = useState<any[]>([]);
    const [sportTypeList, setSportTypeList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [uiSchema, setUiSchema] = useState<any[]>([]);
    const [athleteId, setAthleteId] = useState<any[]>([]);
    const [formatList, setFormatList] = useState<any[]>([]);
    const [countResponse, setCountResponse] = useState<any>({});
    const [formData, setFormData] = useState([]);
    const [compsId, setCompsId] = useState("");
    const [compsName, setCompsName] = useState("");
    const [compsType, setCompsType] = useState("");
    const [compsStatus, setCompsStatus] = useState("");
    const [compVenue, setCompVenue] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [sportId, setSportId] = useState("");
    const [sportTypeId, setSportTypeId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openSportLstModal, setOpenSportLstModal] = useState(false);
    const [sportEventRows, setSportEventRows] = useState([
        { sportcategoryid: "", sporteventid: "", compcategoryid: "", compclassid: "", compformatid: "" }
    ]);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchCompetitions() {
            setIsLoading(true);
            const compCountResponse = await func.competitionCountInfo();
            setCountResponse(compCountResponse || {});
            const compResponse = await func.competitions(null);
            setCompsList(Array.isArray(compResponse) ? compResponse : [])
            setIsLoading(false);
        }
        fetchCompetitions();
    }, [])

    const filteredData = compsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const compNameRender = (rowData) => {
        return <span>{rowData.name}</span>
    };

    const levelNameRender = (rowData) => {
        return <span>{rowData.levelName}</span>
    };

    const genderNameRender = (rowData) => {
        return <span>{rowData.genderName}</span>
    };

    const countryNameRender = (rowData) => {
        return <span>{rowData.countryName}</span>
    };

    const startDateRender = (rowData) => {
        return <span>{formatDate(rowData.fromdate)}</span>
    }

    const endDateRender = (rowData) => {
        return <span>{formatDate(rowData.todate)}</span>
    }

    const compStatus = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    }

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const toInputDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${year}-${month}-${day}`; // <-- input expects this format
    };

    const selectCustom = {
        control: (base) => ({
            ...base,
            borderRadius: "6px",     // tighter radius since the box is smaller
            background: "#FAFAFA",
            border: "none",
            boxShadow: "none",
            minHeight: "45px",       // ensures it never grows taller
            height: "45px",          // fixed height
        }),
        valueContainer: (base) => ({
            ...base,
            height: "45px",          // matches control
            display: "-webkit-inline-box",
            alignItems: "center",    // centers text vertically
            padding: "0 6px",        // adjust padding to avoid text clipping
        }),
        input: (base) => ({
            ...base,
            margin: "0px",
            padding: "0px",
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: "45px",          // make dropdown arrow fit
        }),
        dropdownIndicator: (base) => ({
            ...base,
            padding: "2px",          // tighter padding for small height
        }),
        clearIndicator: (base) => ({
            ...base,
            padding: "2px",          // smaller clear (x) button
        }),
        placeholder: (base) => ({
            ...base,
            color: "#aaa",
        }),
        singleValue: (base) => ({
            ...base,
            color: "#333",
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    };

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
            height: '45px', // fixed height for consistency
        }),
        valueContainer: (base) => ({
            ...base,
            height: "45px",          // matches control
            display: "-webkit-inline-box",
            alignItems: "center",    // centers text vertically
            padding: "0 6px",        // adjust padding to avoid text clipping
        }),
        input: (base) => ({
            ...base,
            margin: "0px",
            padding: "0px",
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: "45px",          // make dropdown arrow fit
        }),
        dropdownIndicator: (base) => ({
            ...base,
            padding: "2px",          // tighter padding for small height
        }),
        clearIndicator: (base) => ({
            ...base,
            padding: "2px",          // smaller clear (x) button
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    async function newCompetitions() {
        setOpenModal(true);
        setIsEdit(false)
        setCompsName("");
        setCompsType("");
        setCompVenue("");
        setStartDate("");
        setEndDate("");
        setSportEventRows([]);
        setOpenSportLstModal(false)
        const uiSchemaResponse = await func.competitionsUiSchema();
        setUiSchema(Array.isArray(uiSchemaResponse.fields) ? uiSchemaResponse.fields : [])
    }

    async function addSportEvent() {
        const sprtCatResponse = await func.sportCategory(null);
        setSportTypeList(Array.isArray(sprtCatResponse) ? sprtCatResponse : [])

        if (sportEventRows.length < 5) {
            setSportEventRows([
                ...sportEventRows,
                { sportcategoryid: "", sporteventid: "", compcategoryid: "", compclassid: "", compformatid: "" }
            ]);
        } else {
            Swal.fire("You can add only upto 5 events per competition.");
        }
    }

    function removeSportEvent(index: number) {
        setSportEventRows(sportEventRows.filter((_, i) => i !== index));
    }

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editCompetition(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const compId = rowData.competitionId;
        return (
            <Link to="#" onClick={() => deleteCompetition(compId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function editCompetition(rowData: { competitionId: any; }) {
        const comptypid = rowData.competitionId;
        setIsEdit(true)
        const compTypeResponse = await func.competitionType(null);
        setCompTypeList(Array.isArray(compTypeResponse) ? compTypeResponse : [])
        const getDetails = await func.competitions(comptypid);
        setCompsId(getDetails.competitionId);
        setCompsName(getDetails.competitionName);
        setCompsType(getDetails.competitionTypeId);
        setCompVenue(getDetails.venue);
        setCompsStatus(getDetails.status);
        setStartDate(toInputDate(getDetails.startDate));
        setEndDate(toInputDate(getDetails.endDate));
        setOpenModal(true)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateCompetitions();
            } else {
                if (sportEventRows.length === 0) {
                    Swal.fire({
                        title: 'Error',
                        text: 'Please add at least one sport event.',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    });
                    return;
                }
                const formDta = new FormData();
                Object.keys(formData).forEach((key) => {
                    formDta.append(key, formData[key]);
                });

                formDta.append("sportEvents", JSON.stringify(sportEventRows));

                const createComps = api.competitions;
                fetch(createComps, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formDta
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                    // sprtCochMdl();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    async function sprtCochMdl() {
        const compResponse = await func.competitions(null);
        setCompsList(Array.isArray(compResponse) ? compResponse : [])
        const sprtResponse = await func.competitionSport(null);
        setSportList(Array.isArray(sprtResponse) ? sprtResponse : [])
        const athleteResponse = await func.listActiveAthletes();
        setAthleteList(Array.isArray(athleteResponse) ? athleteResponse : [])
        const compSprtTypeResponse = await func.competitionSportType(null);
        setSportTypeList(Array.isArray(compSprtTypeResponse) ? compSprtTypeResponse : [])
        setOpenModal(false)
        setOpenSportLstModal(true)
    }

    function saveSportLst(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            const formData = new FormData();
            formData.append("competitionId", compsId);
            formData.append("sportId", sportId);
            formData.append("sportTypeId", sportTypeId);
            formData.append("athlete", JSON.stringify(athleteId.map(Number)));
            // formData.append("totalParticipants", totParticipants);
            const createSportList = api.sportList;
            fetch(createSportList, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
        }
    }

    function updateCompetitions() {
        const formData = new FormData();
        formData.append("name", compsName);
        formData.append("type", compsType);
        formData.append("venue", compVenue);
        formData.append("startDate", startDate);
        formData.append("endDate", endDate);
        formData.append("status", compsStatus);
        const updateCompTyp = api.competitions + "/" + compsId;
        fetch(updateCompTyp, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteCompetition(compid: string) {
        const delteComp = api.competitions + "/" + compid + "/0";
        fetch(delteComp, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    const renderField = (field: any) => {
        switch (field.type) {
            case "text":
            case "date":
                return (
                    <input
                        type={field.type}
                        name={field.name}
                        required={field.required || false}
                        value={formData[field.name] || ""}
                        onChange={handleChange}
                        className="form-control"
                        style={{ height: "45px" }}
                    />
                );

            case "select":
                return (
                    <Select
                        value={field.options.find(cmp => cmp.id === formData[field.name]) ? {
                            value: formData[field.name],
                            label: field.options.find(cmp => cmp.id === formData[field.name]).name
                        } : null}
                        // onChange={handleSelectChange}
                        onChange={(selectedOption) =>
                            handleSelectChange(selectedOption, field.name)
                        }
                        styles={customSelect}
                        required
                        placeholder="Select Level"
                        options={field.options.map(cmp => ({
                            value: cmp.id,
                            label: cmp.name
                        }))}>
                    </Select>
                );

            default:
                return null;
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData((prev: any) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSelectChange = (selectedOption: any, fieldName: string) => {
        setFormData((prev: any) => ({
            ...prev,
            [fieldName]: selectedOption?.value || "",
        }));
    };

    const handleSubmite = (e: React.FormEvent) => {
        e.preventDefault();

        console.log("Submitted Data:", formData);
    };

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Events</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newCompetitions() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Event">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="card dashboard-card statistics-card">
                                    <div className="row justify-content-center">
                                        {Object.entries(countResponse).map(([key, value]) => (
                                            <div className="col-lg-3" key={key}>
                                                <div className="statistics-grid flex-fill justify-content-center">
                                                    <div className="statistics-content">
                                                        <h5 className="card-title">
                                                            {key
                                                                .replace(/([A-Z])/g, " $1")
                                                                .replace(/^./, str => str.toUpperCase())}
                                                        </h5>
                                                        <h3 className="text-center">{value}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="name"
                                                header="Event"
                                                body={compNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="levelName"
                                                header="Level"
                                                body={levelNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="genderName"
                                                header="Gender"
                                                body={genderNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="venue"
                                                header="Venue"
                                                body={countryNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="startDate"
                                                header="Start Date"
                                                body={startDateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="endDate"
                                                header="End Date"
                                                body={endDateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={compStatus}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {openModal && (
                <Modal
                    show={openModal}
                    size="xl"
                    centered>
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Event</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        {/* <form ref={formRef}>
                            <div className="row">
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Event</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="competitionName"
                                            placeholder="Enter Event Name"
                                            required
                                            value={compsName}
                                            onChange={(e) => setCompsName(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Level</label>
                                        <Select
                                            value={compTypeList.find(cmp => cmp.competitionTypeId === compsType) ? {
                                                value: compsType,
                                                label: compTypeList.find(cmp => cmp.competitionTypeId === compsType).competitionTypeName
                                            } : null}
                                            onChange={async (e) => {
                                                setCompsType(e.value);
                                            }}
                                            required
                                            placeholder="Select Level"
                                            options={compTypeList.map(cmp => ({
                                                value: cmp.competitionTypeId,
                                                label: cmp.competitionTypeName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Venue</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="competitionName"
                                            placeholder="Enter Venue"
                                            required
                                            value={compVenue}
                                            onChange={(e) => setCompVenue(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Start Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="startDate"
                                            placeholder="Enter Start Date"
                                            required
                                            value={startDate}
                                            onChange={(e) => setStartDate(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">End Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="endDate"
                                            placeholder="Enter End Date"
                                            required
                                            value={endDate}
                                            onChange={(e) => setEndDate(e.target.value)}
                                        />
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="col-lg-6 mt-10">
                                            <div className="row">
                                                <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                    <label className="form-label">Status</label>
                                                </div>
                                                <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                    <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                        <input
                                                            className="form-check-input text-end"
                                                            type="checkbox"
                                                            checked={compsStatus === '1'}
                                                            id="scdlStatus"
                                                            onChange={(e) => {
                                                                setCompsStatus(e.target.checked ? '1' : '0')
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                            </div>
                            <ModalFooter>
                                <Button
                                    className="btn-primary text-uppercase"
                                    variant="success"
                                    type="submit"
                                    onClick={handleSubmit}
                                >
                                    <b><i className="fas fa-save" />Save</b>
                                </Button>
                            </ModalFooter>
                        </form> */}
                        <form ref={formRef}>
                            <div className="row">
                                {uiSchema.map((field: any, index: number) => (
                                    <div className="col-lg-4 mb-3" key={index}>
                                        <label className="form-label">
                                            {field.label}

                                            {field.required && (
                                                <span className="text-danger ms-1">*</span>
                                            )}
                                        </label>

                                        {renderField(field)}
                                    </div>
                                ))}
                            </div>
                            <div className="row">
                                <div className="col d-flex justify-content-between">
                                    <h4>Sport Event</h4>
                                    <Link
                                        to="#"
                                        className="btn text-end"
                                        onClick={() => { addSportEvent() }}
                                        data-bs-toggle="tooltip"
                                        style={{ fontSize: "24px", padding: "0px" }}
                                        title="Add Sport Event">
                                        <i className="feather-plus" />&nbsp;
                                    </Link>
                                </div>
                            </div>
                            {sportEventRows.map((row, index) => (
                                <>
                                    <div className="row" key={index}>
                                        <Link
                                            to="#"
                                            className="btn text-end"
                                            onClick={() => { removeSportEvent(index) }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Remove Sport Event">
                                            <i className="feather-minus" />&nbsp;
                                        </Link>
                                        <div className="col-lg-3 mb-10">
                                            <div className="input-space">
                                                <label className="form-label">Sport Category</label>
                                                <Select
                                                    value={sportTypeList.find(spTyp => spTyp.id === row.sportcategoryid) ? {
                                                        value: row.sportcategoryid,
                                                        label: sportTypeList.find(spTyp => spTyp.id === row.sportcategoryid).name
                                                    } : null}
                                                    onChange={async (e) => {
                                                        const updatedRows = [...sportEventRows];
                                                        updatedRows[index].sportcategoryid = e.value;
                                                        setSportEventRows(updatedRows);
                                                        const sprtResponse = await func.listSportByCategory(e.value);
                                                        setSportList(Array.isArray(sprtResponse) ? sprtResponse : [])
                                                    }}
                                                    styles={selectCustom}
                                                    required
                                                    placeholder="Select Sport Category"
                                                    options={sportTypeList.map(spTyp => ({
                                                        value: spTyp.id,
                                                        label: spTyp.name
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 mb-10">
                                            <div className="input-space">
                                                <label className="form-label">Sport</label>
                                                <Select
                                                    value={sportList.find(sprt => sprt.sportsId === row.sporteventid) ? {
                                                        value: row.sporteventid,
                                                        label: sportList.find(sprt => sprt.sportsId === row.sporteventid).sportsName
                                                    } : null}
                                                    onChange={async (e) => {
                                                        const updatedRows = [...sportEventRows];
                                                        updatedRows[index].sporteventid = e.value;
                                                        setSportEventRows(updatedRows);
                                                        const compCatResponse = await func.competitionClassesBySport(e.value);
                                                        setCompCatList(Array.isArray(compCatResponse) ? compCatResponse : [])
                                                        const classResponse = await func.competitionCategoriesBySport(e.value);
                                                        setClassList(Array.isArray(classResponse) ? classResponse : [])
                                                        const formatResponse = await func.competitionFormatBySport(e.value);
                                                        setFormatList(Array.isArray(formatResponse) ? formatResponse : [])
                                                    }}
                                                    styles={selectCustom}
                                                    required
                                                    placeholder="Select Sport"
                                                    options={sportList.map(sprt => ({
                                                        value: sprt.sportsId,
                                                        label: sprt.sportsName
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 mb-10">
                                            <div className="input-space">
                                                <label className="form-label">Event Category</label>
                                                <Select
                                                    value={compCatList.find(cat => cat.id === row.compcategoryid) ? {
                                                        value: row.compcategoryid,
                                                        label: compCatList.find(cat => cat.id === row.compcategoryid).name
                                                    } : null}
                                                    onChange={async (e) => {
                                                        const updatedRows = [...sportEventRows];
                                                        updatedRows[index].compcategoryid = e.value;
                                                        setSportEventRows(updatedRows);
                                                    }}
                                                    styles={selectCustom}
                                                    required
                                                    placeholder="Select EventCategory"
                                                    options={compCatList.map(cat => ({
                                                        value: cat.id,
                                                        label: cat.name
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 mb-10">
                                            <div className="input-space">
                                                <label className="form-label">Event Class</label>
                                                <Select
                                                    value={classList.find(cls => cls.id === row.compclassid) ? {
                                                        value: row.compclassid,
                                                        label: classList.find(cls => cls.id === row.compclassid).name
                                                    } : null}
                                                    onChange={async (e) => {
                                                        const updatedRows = [...sportEventRows];
                                                        updatedRows[index].compclassid = e.value;
                                                        setSportEventRows(updatedRows);
                                                    }}
                                                    styles={selectCustom}
                                                    required
                                                    placeholder="Select EventClass"
                                                    options={classList.map(cls => ({
                                                        value: cls.id,
                                                        label: cls.name
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 mb-10">
                                            <div className="input-space">
                                                <label className="form-label">Event Format</label>
                                                <Select
                                                    value={formatList.find(fmt => fmt.id === row.compformatid) ? {
                                                        value: row.compformatid,
                                                        label: formatList.find(fmt => fmt.id === row.compformatid).name
                                                    } : null}
                                                    onChange={async (e) => {
                                                        const updatedRows = [...sportEventRows];
                                                        updatedRows[index].compformatid = e.value;
                                                        setSportEventRows(updatedRows);
                                                    }}
                                                    styles={selectCustom}
                                                    required
                                                    placeholder="Select Event Format"
                                                    options={formatList.map(fmt => ({
                                                        value: fmt.id,
                                                        label: fmt.name
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ))}
                            <ModalFooter>
                                <Button
                                    className="btn-primary text-uppercase"
                                    variant="success"
                                    type="submit"
                                    onClick={handleSubmit}
                                >
                                    <b><i className="fas fa-save" />Save</b>
                                </Button>
                            </ModalFooter>
                        </form>
                    </ModalBody>
                </Modal>
            )}

            {openSportLstModal && (
                <Modal
                    show={openSportLstModal}
                    size="lg"
                    centered
                >
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case">Add Competitors</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenSportLstModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <form ref={formRef}>
                            <div className="row">
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Event</label>
                                        <Select
                                            value={compsList.find(comp => comp.competitionId === compsId) ? {
                                                value: compsId,
                                                label: compsList.find(comp => comp.competitionId === compsId).competitionName
                                            } : null}
                                            onChange={async (e) => {
                                                setCompsId(e.value);
                                            }}
                                            required
                                            placeholder="Select Event"
                                            options={compsList.map(comp => ({
                                                value: comp.competitionId,
                                                label: comp.competitionName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Category
                                            <span className="text-danger ms-1">*</span>
                                        </label>
                                        <Select
                                            value={sportTypeList.find(spTyp => spTyp.competitionSportsTypeId === sportTypeId) ? {
                                                value: sportTypeId,
                                                label: sportTypeList.find(spTyp => spTyp.competitionSportsTypeId === sportTypeId).SportTypeName
                                            } : null}
                                            onChange={async (e) => {
                                                setSportTypeId(e.value);
                                            }}
                                            required
                                            placeholder="Select Category"
                                            options={sportTypeList.map(spTyp => ({
                                                value: spTyp.competitionSportsTypeId,
                                                label: spTyp.SportTypeName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Sport
                                            <span className="text-danger ms-1">*</span>
                                        </label>
                                        <Select
                                            value={sportList.find(sprt => sprt.competitionsportsId === sportId) ? {
                                                value: sportId,
                                                label: sportList.find(sprt => sprt.competitionsportsId === sportId).sportName
                                            } : null}
                                            onChange={async (e) => {
                                                setSportId(e.value);
                                            }}
                                            required
                                            placeholder="Select Sport"
                                            options={sportList.map(sprt => ({
                                                value: sprt.competitionsportsId,
                                                label: sprt.sportName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Add Athletes</label>
                                        <Select
                                            isMulti={!isEdit}
                                            value={Array.isArray(athleteList)
                                                ? athleteList
                                                    .filter(athlt => athleteId.includes(athlt.userId))
                                                    .map(athlt => ({
                                                        value: athlt.userId,
                                                        label: athlt.athleteName
                                                    }))
                                                : []
                                            }
                                            onChange={(selectedOptions) => {
                                                // const selectedIds = selectedOptions.map(option => option.value);
                                                const selectedIds = Array.isArray(selectedOptions)
                                                    ? selectedOptions.map(option => option.value)
                                                    : selectedOptions
                                                        ? [selectedOptions.value]
                                                        : [];
                                                setAthleteId(selectedIds);
                                            }}
                                            options={Array.isArray(athleteList)
                                                ? athleteList.map(athlt => ({
                                                    value: athlt.userId,
                                                    label: athlt.athleteName
                                                }))
                                                : []
                                            }
                                        />
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={sportStatus === '1'}
                                                        id="scdlStatus"
                                                        onChange={(e) => {
                                                            setSportStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                            </div>
                            <ModalFooter>
                                <Button
                                    className="btn-primary text-uppercase"
                                    variant="success"
                                    type="submit"
                                    onClick={saveSportLst}
                                >
                                    <b><i className="fas fa-save" />Save</b>
                                </Button>
                            </ModalFooter>
                        </form>
                    </ModalBody>
                </Modal>
            )}
        </>
    )
};

export default Competitions;